import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-dark py-12 px-4 text-center relative z-10" data-id="element-79">
        <div className="max-w-4xl mx-auto" data-id="element-80">
          <p className="text-white font-bold text-2xl mb-6 font-display" data-id="element-81">
            Mamá IA 2026
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-slate-400 text-sm mb-8 font-medium" data-id="element-82">
            <button onClick={() => setActiveModal('terms')} className="hover:text-primary transition-colors" data-id="element-83">
              Términos y Condiciones
            </button>
            <span className="text-slate-600" data-id="element-84">|</span>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-primary transition-colors" data-id="element-85">
              Política de Privacidad
            </button>
            <span className="text-slate-600" data-id="element-86">|</span>
            <button onClick={() => setActiveModal('contact')} className="hover:text-primary transition-colors" data-id="element-87">
              Contacto
            </button>
          </div>

          <p className="text-slate-500 text-xs leading-relaxed max-w-3xl mx-auto" data-id="element-88">
            © {new Date().getFullYear()} Mamá IA. Todos los derechos
            reservados.
            <br data-id="element-89" />
            <br data-id="element-90" />
            Este sitio web no forma parte de Facebook ni de Meta Platforms, Inc.
            Además, este sitio NO está respaldado por Meta de ninguna manera.
            Meta es una marca comercial de Meta Platforms, Inc.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-91">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-92">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="absolute inset-0 bg-dark/80 backdrop-blur-sm" data-id="element-93" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-2xl bg-white rounded-[24px] shadow-2xl overflow-hidden flex flex-col max-h-[85vh]" data-id="element-94">
              <div className="flex items-center justify-between p-6 border-b border-border" data-id="element-95">
                <h3 className="text-2xl font-display font-bold text-dark" data-id="element-96">
                  {activeModal === 'privacy' && 'Política de Privacidad'}
                  {activeModal === 'terms' && 'Términos y Condiciones'}
                  {activeModal === 'contact' && 'Contacto y Soporte'}
                </h3>
                <button onClick={closeModal} className="p-2 text-slate-400 hover:text-dark hover:bg-slate-100 rounded-full transition-colors" data-id="element-97">
                  <X className="w-6 h-6" data-id="element-98" />
                </button>
              </div>

              <div className="p-6 md:p-8 overflow-y-auto text-body space-y-6" data-id="element-99">
                {activeModal === 'privacy' && <>
                    <p className="text-sm text-slate-500 font-medium" data-id="element-100">
                      Última actualización: 6 de abril de 2026
                    </p>
                    <p data-id="element-101">
                      En El Sistema Mamá IA, valoramos tu privacidad. Esta
                      política describe cómo recopilamos y usamos tu
                      información.
                    </p>

                    <div data-id="element-102">
                      <h4 className="font-bold text-dark text-lg mb-2" data-id="element-103">
                        Recopilación de Datos
                      </h4>
                      <p data-id="element-104">
                        Recopilamos tu nombre y correo electrónico únicamente
                        para la entrega del producto digital y comunicaciones
                        relacionadas con tu compra.
                      </p>
                    </div>

                    <div data-id="element-105">
                      <h4 className="font-bold text-dark text-lg mb-2" data-id="element-106">
                        Uso de Datos
                      </h4>
                      <p data-id="element-107">
                        Tus datos no serán vendidos ni compartidos con terceros.
                        Se utilizan para procesar pagos de forma segura y
                        mejorar tu experiencia de usuario.
                      </p>
                    </div>

                    <div data-id="element-108">
                      <h4 className="font-bold text-dark text-lg mb-2" data-id="element-109">
                        Cookies
                      </h4>
                      <p data-id="element-110">
                        Utilizamos píxeles (como el de Meta) para medir la
                        efectividad de nuestra publicidad y ofrecerte contenido
                        relevante.
                      </p>
                    </div>

                    <div data-id="element-111">
                      <h4 className="font-bold text-dark text-lg mb-2" data-id="element-112">
                        Derechos
                      </h4>
                      <p data-id="element-113">
                        Puedes solicitar la eliminación de tus datos en
                        cualquier momento enviando un correo a nuestro soporte.
                      </p>
                    </div>
                  </>}

                {activeModal === 'terms' && <>
                    <div data-id="element-114">
                      <h4 className="font-bold text-dark text-lg mb-2" data-id="element-115">
                        1. Naturaleza del Servicio
                      </h4>
                      <p data-id="element-116">
                        "El Sistema Mamá IA" es un producto educativo digital
                        (Ebook/Guía). No garantizamos ingresos específicos, ya
                        que los resultados dependen del esfuerzo y la
                        implementación de cada usuario.
                      </p>
                    </div>

                    <div data-id="element-117">
                      <h4 className="font-bold text-dark text-lg mb-2" data-id="element-118">
                        2. Propiedad Intelectual
                      </h4>
                      <p data-id="element-119">
                        Todo el contenido es propiedad de El Sistema Mamá IA.
                        Queda prohibida la reventa o distribución no autorizada
                        de este material.
                      </p>
                    </div>

                    <div data-id="element-120">
                      <h4 className="font-bold text-dark text-lg mb-2" data-id="element-121">
                        3. Política de Reembolso
                      </h4>
                      <p data-id="element-122">
                        Ofrecemos una garantía de satisfacción de 7 días. Si el
                        producto no cumple con tus expectativas, puedes
                        solicitar un reembolso total dentro de este periodo.
                      </p>
                    </div>

                    <div data-id="element-123">
                      <h4 className="font-bold text-dark text-lg mb-2" data-id="element-124">
                        4. Descargo de Responsabilidad (Earnings Disclaimer)
                      </h4>
                      <p data-id="element-125">
                        Este sitio no es parte del sitio web de Facebook o
                        Facebook Inc. Además, este sitio NO está respaldado por
                        Facebook de ninguna manera. FACEBOOK es una marca
                        registrada de FACEBOOK, Inc.
                      </p>
                    </div>
                  </>}

                {activeModal === 'contact' && <>
                    <p className="text-lg font-medium text-dark" data-id="element-126">
                      ¿Tienes dudas o necesitas ayuda con tu acceso?
                    </p>
                    <p data-id="element-127">
                      Estamos aquí para apoyarte. Nuestro equipo de soporte
                      responde en menos de 24 horas (Lunes a Viernes).
                    </p>

                    <div className="bg-slate-50 p-6 rounded-xl border border-border space-y-4 mt-6" data-id="element-128">
                      <div data-id="element-129">
                        <span className="block text-sm font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-130">
                          Email
                        </span>
                        <a href="mailto:contacto@vitarutinas.com" className="text-primary font-medium hover:underline text-lg" data-id="element-131">
                          contacto@vitarutinas.com
                        </a>
                      </div>

                      <div data-id="element-132">
                        <span className="block text-sm font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-133">
                          Ubicación
                        </span>
                        <span className="text-dark font-medium text-lg" data-id="element-134">
                          Soporte Digital Global
                        </span>
                      </div>
                    </div>
                  </>}
              </div>

              <div className="p-6 border-t border-border bg-slate-50 text-right" data-id="element-135">
                <button onClick={closeModal} className="px-6 py-2 bg-dark text-white font-medium rounded-full hover:bg-slate-800 transition-colors" data-id="element-136">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}